import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";
import { useIsMobile } from '@/hooks/use-mobile';
import ReservationFlow from '@/components/reservation/ReservationFlow';

interface ReservationModalProps {
  isOpen: boolean;
  onClose: () => void;
  restaurantId: string;
  restaurantName: string;
}

export const ReservationModal: React.FC<ReservationModalProps> = ({ isOpen, onClose, restaurantId, restaurantName }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
        <DrawerContent className="max-h-[95vh]">
          <DrawerHeader className="pb-0">
            <DrawerTitle className="text-lg">Réserver chez {restaurantName}</DrawerTitle>
            <DrawerDescription className="text-sm">
              Réservez votre table en quelques clics
            </DrawerDescription>
          </DrawerHeader>
          <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
            <ReservationFlow restaurantId={restaurantId} onClose={onClose} />
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-hidden flex flex-col p-0">
        <DialogHeader className="px-6 pt-6 pb-0">
          <DialogTitle>Réserver chez {restaurantName}</DialogTitle>
          <DialogDescription>
            Réservez votre table en quelques clics
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
          <ReservationFlow restaurantId={restaurantId} onClose={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReservationModal;
